export default __webpack_public_path__ + "static/media/08.38d1be25.png";